module.exports = __webpack_public_path__ + "static/img/about_img_c.7ea78db7.png";